<template>
  <div
    v-if="typeLabel && typeIcon"
    id="info-request"
    class="info-request i-py-7 i-px-8 d-flex"
  >
    <div class="d-flex align-items-center i-mr-8">
      <i-icon :symbol="typeIcon" :size="16"></i-icon>
    </div>
    <div class="d-flex flex-column flex-grow-1">
      <p class="i-text-body-3 i-text-neutral-110">{{ typeLabel }}</p>
      <p
        :class="
          hasResponse
            ? 'i-text-button-3 i-text-neutral-120'
            : 'i-text-body-3 i-text-neutral-90'
        "
      >
        {{ responseText }}
      </p>
    </div>
    <div v-if="hasResponse" class="d-flex align-items-center copy-button">
      <i-button
        id="copy-btn"
        :left-icon="'small-edit-copy'"
        :size="iButtonSizes.SMALL"
        :type="iButtonTypes.NEUTRAL"
        :button-style="iButtonStyles.OUTLINE"
        @button-click="copy(responseText)"
      />
      <i-tooltip
        :target="`#copy-btn`"
        title="Copied!"
        :alignment="iTooltipAlignmentMode.TOP_MIDDLE"
      />
    </div>
  </div>
</template>

<script>
import {
  iIcon,
  iButton,
  iButtonSizes,
  iButtonStyles,
  iButtonTypes,
  iTooltip,
  iTooltipAlignmentMode,
} from '@inscribe/signal';
import { copyText } from '@/utils/copyText';
import * as request from '@/constants/informationRequestTypes';

export default {
  components: {
    iIcon,
    iButton,
    iTooltip,
  },
  props: {
    type: {
      type: String,
      default: undefined,
    },
    response: {
      type: Array,
      default: undefined,
    },
  },
  data() {
    return {
      iButtonSizes,
      iButtonStyles,
      iButtonTypes,
      iTooltipAlignmentMode,
    };
  },
  computed: {
    hasResponse() {
      return this.response.length > 0;
    },
    responseText() {
      return this.hasResponse
        ? this.response[0].value.value
        : 'Awaiting customer response';
    },
    typeIcon() {
      return request.TYPE_MAP[this.type]
        ? request.TYPE_MAP[this.type]?.icon
        : undefined;
    },
    typeLabel() {
      return request.TYPE_MAP[this.type]
        ? request.TYPE_MAP[this.type]?.label
        : undefined;
    },
  },
  methods: {
    copy(text) {
      copyText(text);
      setTimeout(() => {
        this.$root.$emit('bv::hide::tooltip');
      }, 1000);
    },
  },
};
</script>

<style lang="scss" scoped>
.info-request {
  border: 1px solid $light-neutral-60;
  border-radius: 16px;

  .copy-button {
    opacity: 0;
  }
  .i-icon {
    color: $light-neutral-90 !important;
  }

  &:hover,
  &:focus {
    .copy-button {
      opacity: 1;
    }
  }
}
</style>
